import * as React from 'react'

const SvgCloseFilledIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 1.25A8.696 8.696 0 001.25 10 8.696 8.696 0 0010 18.75 8.696 8.696 0 0018.75 10 8.696 8.696 0 0010 1.25zm3.375 13.125L10 11l-3.375 3.375-1-1L9 10 5.625 6.625l1-1L10 9l3.375-3.375 1 1L11 10l3.375 3.375-1 1z"
      fill="#163250"
    />
  </svg>
)

export default SvgCloseFilledIcon
